import React from 'react'
import { Box, Divider, IconButton, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import ShareThis from '../../../_common/ShareThis';
import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import ChartItem from '../../../_common/Skeleton/chart';
import dynamic from 'next/dynamic';
const D3Chart = dynamic(() => import('../../../_common/D3Chart'),
  { loading: () => <ChartItem /> })
// import Clipboard from '../../../_common/Clipboard';
import { dataConstants } from '../../../../constants';
import { getRandomStr, getTabData } from '../../../../helpers';
// import { getChartSeriesColor } from '../../../../utils';
// import CloseFullscreenRoundedIcon from '@mui/icons-material/CloseFullscreenRounded';
import CollapseCard from '../../CollapseCard';

const { ECO_SECTION_CODES } = dataConstants || {};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  '&:hover button, .share-wrapper': {
    visibility: 'visible'
  },
  '& .Item-Head': {
    background: '#f2f2f2',
    borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: '4px 4px 0 0',
    '& a': {
      textDecoration: 'none',
      color: '#333',
      fontWeight: 600,
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '.option-desc .MuiTypography-caption': {
    color: "#333 !important",
  },
  '& .option-content .option-desc': {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  '& button, .share-wrapper': {
    visibility: 'hidden'
  },
  '& .MuiGrid-root': {
    width: '100% !important',
    margin: 0,
  },
  '& .MuiGrid-root > .MuiGrid-item': {
    padding: 0,
    marginLeft: 0,
    marginRight: 0,
  },
}));

function GDPGrowthBreakUp({ data, gdata, themes, onChangeInfo, handleClick, getChartData, selectedInfo }) {

  const gdpBreak = data && data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_CHART) ? data.find(d => d.section_code === ECO_SECTION_CODES.GDP_BREAK_CHART) : undefined;
  const gdpBreakChart = gdpBreak && gdpBreak.tabData ? getChartData(gdpBreak.tabData, getTabData(gdata, gdpBreak, ECO_SECTION_CODES.GDP_BREAK)) : undefined;

  return (
    <>
      {gdpBreak && gdpBreakChart &&
        <Item component="div" className="col-md-4">
          <Box
            className="Item-Head"
            sx={{
              display: 'flex',
              alignItems: 'center',
              // mb: 1.4,
              px: 0.5,
            }}
          >
            <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
              {gdpBreak.section_name}
            </Typography>
            {/* <IconButton aria-label="info" onClick={() => onChangeInfo(gdpBreak.section_code)} >
              <InfoRoundedIcon size="small" sx={{ fontSize: '1.1rem', color: 'text.link' }} />
            </IconButton> */}
            <ShareThis
              link={encodeURI(`${process.env.NEXT_PUBLIC_URL}${dataConstants.NAVS.CHART_SHARE}/${gdpBreakChart.code}/${gdpBreakChart.series.map(d => d.yformula).join(';')}/${gdpBreak.section_name}`)}
              title={`${gdpBreak.section_name}`}
              message={`${gdpBreak.section_name}`}
              subject={''}
            />
          </Box>
          {gdpBreakChart && gdpBreakChart.description && <Box sx={{ mt: 2, px: 2, textAlign: 'left' }} component="div" className="option-desc"><Typography variant="caption" sx={{ fontSize: '.875rem' }} dangerouslySetInnerHTML={{ __html: gdpBreakChart.description }} /></Box>}
          {/* <Box
            component="ul"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
              listStyle: 'none',
              p: 0.5,
              m: 0,
              justifyContent: 'flex-start',
            }}
            className="gdp-break-legends">
            {gdpBreakChart.series.map(d => {
              const { setting, legend } = d || {};
              return (
                <Box
                  key={getRandomStr(3)}
                  component="ul"
                  className="gdp-break-legend"
                  sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    listStyle: 'none',
                    p: 0.5,
                    m: 0,
                  }}>
                  <SquareRoundedIcon className="legend-bar" sx={{ color: setting.rect ? setting.rect.fill : setting.line.stroke, fontSize: '1.2rem', mx: 2 }} size="small" />
                  <Box sx={{ mr: 1 }}>{legend.label}</Box>
                </Box>
              );
            })}
          </Box> */}
          <Box component="div" className="option-content eco-chart" sx={{ position: 'relative', minHeight: { md: '19.3rem', xs: '11.3rem' } }}>
            <D3Chart
              showChart={true}
              noHeader
              // maxHeight={chartProps.maxHeight}
              scale={1}
              // onClick={code => handleClick(code)}
              chart={{ ...gdpBreakChart, id: gdpBreak.section_code, tick: 2 }}
              // userName={`@${chart.code.split('@')[1]}`}
              themes={themes}
              type={dataConstants.CHART_STATE.VIEW}
              // axisTextMargin={chartProps.axisTextMargin}
              chartMargin={{ left: 40, bottom: 48 }}
              axisTextMargin={{ y: 96 }}
              // wrapperClass="StockCardImage"
              showLegend={false}
              showCrosshair
            />
          </Box>
          <CollapseCard
            selectedInfo={selectedInfo}
            section_code={gdpBreak?.section_code}
            chart_codes={gdpBreakChart}
            handleClick={handleClick}
            height={'50vh'}
            sx={{ py: 1 }}
          />
        </Item>}
    </>
  )
}

export default GDPGrowthBreakUp
